import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import type { SocialPostRendition } from './social-post-preview-card';
import type { PostGridCount } from './social-post-look-parts';

export const FACEBOOK_CAPTION_LIMIT = 250;
export const FACEBOOK_REEL_CAPTION_LIMIT = 60;

export type FacebookLook = 'facebook-feed' | 'facebook-reel' | 'facebook-story';

export function facebookLook(card: Pick<SocialPostPreviewCardMetadata, 'postType' | 'media'>): FacebookLook {
  if (card.media.length === 0) {
    return 'facebook-feed';
  }
  if (card.postType === 'reel') {
    return 'facebook-reel';
  }
  if (card.postType === 'story') {
    return 'facebook-story';
  }
  return 'facebook-feed';
}

export const FACEBOOK_RENDITIONS: Record<'single' | 'tall' | 'quarter', SocialPostRendition> = {
  single: { mode: 'fill', width: 660, height: 668 },
  tall: { mode: 'fill', width: 328, height: 668 },
  quarter: { mode: 'fill', width: 328, height: 332 },
};

export function facebookGridRendition(count: PostGridCount, index: number): SocialPostRendition {
  return count === 2 || (count === 3 && index === 0) ? FACEBOOK_RENDITIONS.tall : FACEBOOK_RENDITIONS.quarter;
}

export function facebookLinkLabel(link: string): string | undefined {
  try {
    const { hostname, pathname } = new URL(link);
    const host = hostname.replace(/^www\./, '');
    return host ? `${host}${pathname === '/' ? '' : readablePath(pathname)}` : undefined;
  } catch {
    return undefined;
  }
}

function readablePath(pathname: string): string {
  try {
    return decodeURI(pathname);
  } catch {
    return pathname;
  }
}
